import { Component, effect, Input, OnDestroy, OnInit, SecurityContext, signal, WritableSignal, Injector, inject, runInInjectionContext } from "@angular/core";
import { Location } from "@angular/common";
import { FormControl, FormGroup, FormArray, AbstractControl } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { Title } from '@angular/platform-browser';
import { DomSanitizer } from '@angular/platform-browser';
import { EModeAffichage } from './mode-affichage';
import { DonneesBaseService } from '../services/donnees-base-service';
import { DefinitionColonne } from '../entites/definition-colonne';
import { ProfilService } from '../services/profil-service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppMainComponent } from '../app.main.component';
import { CategorieEntite } from '../entites/categorie';
import { EventEmitter } from "@angular/core";
import { BehaviorSubject, distinctUntilChanged, Observable, tap, filter } from "rxjs";
import { Subscription } from "rxjs";
import { HttpParams, HttpEventType } from "@angular/common/http";
import { LazyLoadEvent, FilterMetadata, FilterOperator, FilterMatchMode } from "primeng/api";
import { Table } from "primeng/table";

function delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));

}

// This is still an OVERWRITE of the method, but it simulates an overload internally.
const originalTableFilter = Table.prototype.filter; // Keep a reference to the original

Table.prototype.filter = function (value: any, field: string, matchMode: FilterMatchMode, customOperator?: 'and' | 'or') {
    // 'this' refers to the Table instance

    // === THIS IS THE "OVERLOAD" LOGIC AT RUNTIME ===
    // Check if our custom fourth argument is provided and is one of our custom operators
    if (arguments.length === 4 && (customOperator === 'and' || customOperator === 'or')) {
        // ----------------------------------------------------
        // This is the code path for your "overloaded" behavior
        // ----------------------------------------------------
        const filtersForField = this.filters[field];
        if (!filtersForField) {
            this.filters[field] = [];
        }

        this.filters[field].push({
            value: value,
            matchMode: matchMode,
            operator: customOperator === 'and' ? FilterOperator.AND : FilterOperator.OR
        });
        // Trigger PrimeNG's internal re-evaluation. Calling original with nulls often works.
        originalTableFilter.call(this, null, null, null);

    } else {
        originalTableFilter.apply(this, arguments as any); // Use apply to pass all original arguments
    }
};

@Component({
    template: '',
})
export class BaseComponent {

    protected titrePagePrincipale: string;
    protected estModifiable: boolean = true;

    protected readonly CATEGORIE_ACCESSOIRE: number = 1;
    protected readonly CATEGORIE_EQUIPEMENT: number = 2;
    protected readonly CATEGORIE_INVENTAIRE: number = 3;
    protected readonly CATEGORIE_OUTILLAGES: number = 4;

    colorImageCache: Map<string, string> = new Map();

    private subscriptions: Subscription[] = [];
    private tableFilters: any[] = [];

    public onModeChange: EventEmitter<EModeAffichage> = new EventEmitter();

    private colonnesFetched: WritableSignal<boolean> = signal(false);

    constructor(protected sdb: DonneesBaseService,
        protected profilService: ProfilService,
        protected route: ActivatedRoute,
        protected routerService: Router,
        public appMain: AppMainComponent
    ) {
        this.modeAffichage = EModeAffichage.Consultation;
    }

    // SÉCURITÉ

    estAutorise(code: string): boolean {
        return this.profilService.estAutoriseTache(code);
    }

    hasRole(role: string): boolean {
        return this.profilService.Profil().roles.some(r => r.nom == role);
    }

    verifierAccesPage(tache: string) {
        if (!this.estAutorise(tache)) {
            this.routerService.navigateByUrl('/access');
        }
    }

    verifierAccesPageAuMoisUnAcces(taches: string[]) {

        var autorise: boolean = false;
        taches.forEach(t => {
            if (this.estAutorise(t)) {
                autorise = true;
            }
        });
        if (!autorise) {
            this.routerService.navigateByUrl('/access');
        }
    }

    //CHARGEMENT

    chargementComplete: boolean = false;

    DemarrerChargement() {
        this.chargementComplete = false;
    }

    CompleterChargement(titrePage: string = '') {

        this.chargementComplete = true;
        this.titrePagePrincipale = titrePage;

        if (titrePage.length > 0) {
            this.route.url.subscribe(x => {
                this.profilService.ajouterHistorique({
                    description: titrePage,
                    url: x.join('/')
                })
            });
        }
    }

    EstCharge() {
        return this.chargementComplete;
    }

    public Bloquer() {
        this.appMain.Bloquer();
    }

    public Debloquer() {
        this.appMain.Debloquer();
    }

    // MODE AFFICHAGE

    modeAffichage: EModeAffichage;

    public modeConsultation(): boolean {
        return this.modeAffichage == EModeAffichage.Consultation;
    }

    public modeAjout(): boolean {
        return this.modeAffichage == EModeAffichage.Ajout;
    }

    public modeModification(): boolean {
        return this.modeAffichage == EModeAffichage.Modification;
    }

    public modeAjoutModification(): boolean {
        return this.modeAffichage == EModeAffichage.Ajout || this.modeAffichage == EModeAffichage.Modification;
    }

    public Consulter() {
        this.onModeChange.emit(EModeAffichage.Consultation);
        this.modeAffichage = EModeAffichage.Consultation;
    }

    public Modifier() {
        this.onModeChange.emit(EModeAffichage.Modification);
        this.modeAffichage = EModeAffichage.Modification;
    }

    public Ajouter() {
        this.onModeChange.emit(EModeAffichage.Ajout);
        this.modeAffichage = EModeAffichage.Ajout;
    }

    get LargeurDialogue(): string {
        const width = window.innerWidth;
        if (width >= 1200) return '50%';
        if (width >= 992) return '60%';
        if (width >= 768) return '70%';
        if (width >= 576) return '80%';
        return '90%';
    }

    get isMobile(): boolean {
        return window.innerWidth <= 991;
    }

    public newGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    // FAVORIS



    //GESTION DES COLONNES

    colonnesDisponibles: DefinitionColonne[];
    private _colonnesSelectionnees: DefinitionColonne[];

    get colonnesSelectionnees(): DefinitionColonne[] {
        return this._colonnesSelectionnees;
    }

    set colonnesSelectionnees(val: DefinitionColonne[]) {
        this._colonnesSelectionnees = val;
        if (this.colonnesFetched()) {
            this.sauvegarderColonnesSelectionnees();
        }
    }

    EstColonneSelectionnee(champ: string): boolean {
        return this.colonnesSelectionnees.filter(x => x.champ == champ).length > 0;
    }

    EstColonneSelectionneeSignal(champ: string, signal: WritableSignal<DefinitionColonne[]>): boolean {
        return signal().filter(x => x.champ == champ).length > 0;
    }


    @Input() get selectedColumns(): any[] {
        return this.colonnesSelectionnees;
    }

    set selectedColumns(val: any[]) {
        this.colonnesSelectionnees = this.colonnesDisponibles.filter(col => val.includes(col));
    }

    /**
     * Generates a localStorage key for storing selected columns based on the current URL.
     * @returns The localStorage key for the current page's selected columns.
     */
    private getColonnesStorageKey(): string {
        const url = this.routerService.url.split('?')[0]; // Remove query params
        return `colonnesSelectionnees_${url}`;
    }

    /**
     * Saves the currently selected columns to localStorage.
     * Empty selections are persisted so that hiding every optional column
     * overwrites a previously saved non-empty list (e.g. Heures / KM).
     */
    private sauvegarderColonnesSelectionnees(): void {
        if (this._colonnesSelectionnees) {
            const key = this.getColonnesStorageKey();
            const champs = this._colonnesSelectionnees.map(col => col.champ);
            localStorage.setItem(key, JSON.stringify(champs));
        }
    }

    /**
     * Loads the selected columns from localStorage.
     * Should be called in ngAfterViewInit after colonnesDisponibles is initialized.
     */
    protected chargerColonnesSelectionnees(): void {
        if (!this.colonnesDisponibles || this.colonnesDisponibles.length === 0) {
            return;
        }

        this.colonnesFetched.set(true);

        const key = this.getColonnesStorageKey();
        const savedChamps = localStorage.getItem(key);

        if (savedChamps) {
            try {
                const champs: string[] = JSON.parse(savedChamps);
                const colonnesSauvegardees = this.colonnesDisponibles.filter(col => champs.includes(col.champ));

                // Only apply if we found valid saved columns
                if (colonnesSauvegardees.length > 0) {
                    this._colonnesSelectionnees = colonnesSauvegardees;
                }
            } catch (e) {
                console.error('Error loading saved columns from localStorage', e);
            }
        }
    }

    /**
     * Resets the selected columns to their default values (afficheParDefaut = true).
     * Also clears the localStorage for this page's columns.
     */
    public reinitialiserColonnesSelectionnees(): void {
        if (!this.colonnesDisponibles || this.colonnesDisponibles.length === 0) {
            return;
        }

        // Remove from localStorage
        const key = this.getColonnesStorageKey();
        localStorage.removeItem(key);

        // Reset to default columns
        this._colonnesSelectionnees = this.colonnesDisponibles.filter(col => col.afficheParDefaut);
    }



    ////////

    public naviguer(url: string) {

        this.routerService.navigateByUrl('/', { skipLocationChange: true }).then(() =>
            this.routerService.navigate([url]));

    }

    public estNulOuUndefined(value: any) {
        return value == null || value == undefined;
    }

    public estChampInvalideRequis(formulaire: FormGroup, control: string): boolean {
        return formulaire.get(control).invalid
            && (formulaire.get(control).dirty || formulaire.get(control).touched)
            && formulaire.get(control).errors.required;
    }
    public normaliserValeur(champ: AbstractControl): string {
        if (champ.value === undefined || champ.value === null || champ.value === '') {
            return null;
        } else {
            return champ.value;
        }
    }

    public normaliserValeurChaine(valeur: string): string {
        if (valeur === undefined || valeur === null || valeur === '') {
            return null;
        } else {
            return valeur;
        }
    }

    public normaliserValeurChainePourexportationExcel(valeur: string): string {
        if (valeur === undefined || valeur === null || valeur === '') {
            return null;
        } else {
            return valeur;
        }
    }

    public validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach((field) => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                if (control.enabled) {
                    control.markAsTouched({ onlySelf: true });
                }
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }



    public async scrollToFirstInvalidControl() {

        await delay(200);

        const firstInvalidControl: HTMLElement = document.querySelector(
            'form [aria-invalid=true]'
        );

        window.scroll({
            top: this.getTopOffset(firstInvalidControl),
            left: 0,
            behavior: 'smooth'
        });

        firstInvalidControl.focus();
    }

    private getTopOffset(controlEl: HTMLElement): number {
        const labelOffset = 50;
        return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
    }

    public formToConsole(formGroup: FormGroup, pad: string = '') {
        Object.keys(formGroup.controls).forEach((field) => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                console.log(pad + field + ' -> enabled: ' + control.enabled + ', valid: ' + control.valid + ' value: ' + control.value + (control.enabled && control.invalid ? '                    **********' : ''));
                if (control.invalid) {
                    console.log(control.errors);
                }
            } else if (control instanceof FormGroup) {
                console.log(pad + field + ' -> enabled: ' + control.enabled + ', valid: ' + control.valid + (control.enabled && control.invalid ? '                    **********' : ''));
                if (control.invalid) {
                    console.log(control.errors);
                }
                this.formToConsole(control, pad + '   ');
            } else if (control instanceof FormArray) {
                for (let control2 of control.controls) {
                    if (control2 instanceof FormControl) {
                        console.log(pad + field + ' -> enabled: ' + control.enabled + ', valid: ' + control.valid + ' value: ' + control.value + (control.enabled && control.invalid ? '                    **********' : ''));
                        if (control.invalid) {
                            console.log(control.errors);
                        }
                    }
                    if (control2 instanceof FormGroup) {
                        console.log(pad + field + ' -> enabled: ' + control.enabled + ', valid: ' + control.valid + (control.enabled && control.invalid ? '                    **********' : ''));
                        if (control.invalid) {
                            console.log(control.errors);
                        }
                        this.formToConsole(control2, pad + '   ');
                    }
                }
            }
        });
    }

    /**
     * Creates a WritableSignal that syncs with a URL query parameter.
     * Compatible with ngModel.
     * 
     * @param paramName The name of the query parameter to sync with
     * @param defaultValue The default value to use if the query parameter is not present
     * @returns A WritableSignal that is synchronized with the query parameter
     */
    protected createParamSignal<T>(paramName: string, defaultValue: T, property: string = null): WritableSignal<T> {
        const injector = inject(Injector);

        // Create a signal with the initial value from the URL or the default
        const initialValue = this.route.snapshot.queryParams[paramName] !== undefined
            ? (property ? { [property]: this.route.snapshot.queryParams[paramName] } : this.route.snapshot.queryParams[paramName])
            : defaultValue;

        const paramSignal = signal<T>(this.fromString<T>(initialValue));

        // Store the signal for coordinated updates
        this.paramSignals.set(paramName, { signal: paramSignal, property: property });

        // Use runInInjectionContext to create an effect
        runInInjectionContext(injector, () => {
            effect(() => {
                const value = paramSignal();
                // Only update URL if the component is initialized
                if (this.chargementComplete) {
                    this.scheduleUrlUpdate();
                }
            });
        });

        // Store the subscriptions for later cleanup
        if (!this.subscriptions) {
            this.subscriptions = [];
        }

        return paramSignal;
    }

    // Map to store all parameter signals for coordinated URL updates
    private paramSignals = new Map<string, { signal: WritableSignal<any>, property: string }>();
    private urlUpdateScheduled = false;

    /**
     * Creates a WritableSignal that syncs with a URL query parameter list.
     * Compatible with ngModel.
     * 
     * @param paramName The name of the query parameter list to sync with
     * @param defaultValue The default value to use if the query parameter list is not present
     * @returns A WritableSignal that is synchronized with the query parameter list
     */
    protected createParamSignalList<T>(paramName: string, defaultValue: T[]): WritableSignal<T[]> {
        const injector = inject(Injector);

        // Create a signal with the initial value from the URL or the default
        const initialValue = this.route.snapshot.queryParams[paramName] !== undefined
            ? this.route.snapshot.queryParams[paramName].split(',')
            : defaultValue;

        const paramSignal = signal<T[]>(initialValue as T[]);

        // Store the signal for coordinated updates
        this.paramSignals.set(paramName, { signal: paramSignal, property: null });

        // Use runInInjectionContext to create an effect
        runInInjectionContext(injector, () => {
            effect(() => {
                const value = paramSignal();
                // Only update URL if the component is initialized
                if (this.chargementComplete) {
                    this.scheduleUrlUpdate();
                }
            });
        });

        // Store the subscriptions for later cleanup
        if (!this.subscriptions) {
            this.subscriptions = [];
        }

        return paramSignal;
    }

    /**
     * Schedules a URL update to avoid race conditions when multiple parameter signals change simultaneously.
     * Uses setTimeout to batch multiple signal changes into a single URL update.
     */
    private scheduleUrlUpdate(): void {
        if (this.urlUpdateScheduled) {
            return;
        }

        this.urlUpdateScheduled = true;
        setTimeout(async () => {
            try {
                // Collect all current parameter values
                const queryParams: { [key: string]: string | null } = {};

                for (const [paramName, signalData] of this.paramSignals) {
                    let value = signalData.signal();
                    value = signalData.property ? value[signalData.property] : value;
                    if (Array.isArray(value)) {
                        queryParams[paramName] = value.length > 0 ? value.join(',') : "";
                    } else {
                        queryParams[paramName] = value != null && value !== '' ? value : null;
                    }
                }

                // Update the URL with all parameters at once
                await this.routerService.navigate([], {
                    queryParams: queryParams,
                    queryParamsHandling: 'merge',
                    replaceUrl: true,
                });
            } finally {
                this.urlUpdateScheduled = false;
            }
        }, 0);
    }

    /**
     * Creates a WritableSignal that syncs with a URL fragment.
     * Compatible with ngModel.
     * 
     * @param fragmentName The name of the fragment to sync with
     * @param defaultValue The default value to use if the fragment is not present
     * @returns A WritableSignal that is synchronized with the fragment
     */
    protected createFragmentSignal<T>(fragmentName: string, defaultValue: string): WritableSignal<string> {
        const injector = inject(Injector);

        // Create a signal with the initial value from the URL or the default
        const initialValue = this.route.snapshot.fragment !== undefined
            ? this.route.snapshot.fragment
            : defaultValue;

        const fragmentSignal = signal<string>(initialValue as string);

        // Use runInInjectionContext to create an effect
        runInInjectionContext(injector, () => {
            effect(() => {
                const value = fragmentSignal();
                // Only update URL if the component is initialized
                if (this.chargementComplete) {
                    this.routerService.navigate([], {
                        fragment: value,
                        replaceUrl: true
                    });
                }
            });
        });

        // Set up a subscription to update the signal when the URL changes
        const urlSubscription = this.route.fragment.pipe(
            distinctUntilChanged((prev, curr) => prev === curr)
        ).subscribe(fragment => {
            const urlValue = fragment !== undefined ? fragment : defaultValue;
            if (urlValue !== fragmentSignal()) {
                fragmentSignal.set(urlValue);
            }
        });

        // Store the subscriptions for later cleanup
        if (!this.subscriptions) {
            this.subscriptions = [];
        }
        this.subscriptions.push(urlSubscription);

        return fragmentSignal;
    }

    /**
     * Creates a WritableSignal that syncs with a local storage.
     * Compatible with ngModel.
     * 
     * @param key The key to use for the local storage.
     * @param defaultValue The default value to use if the local storage is not present.
     * @returns A WritableSignal that is synchronized with the local storage.
     */
    public createLocalStorageSignal<T>(key: string, defaultValue: T): WritableSignal<T> {
        const injector = inject(Injector);

        const initialValue = localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : defaultValue;

        const localStorageSignal = signal<T>(initialValue as T);

        runInInjectionContext(injector, () => {
            effect(() => {
                const value = localStorageSignal();
                if (this.chargementComplete) {
                    localStorage.setItem(key, JSON.stringify(value));
                }
            });
        });

        return localStorageSignal;
    }

    public createTableFilter(defaultValue: LazyLoadEvent = null) {
        const wrapper = {

            setValue(table: Table) {
                if (this._firstLoad) {
                    this.updateTable(table);
                    this._firstLoad = false;
                    this._initScrollWatcher();
                    return;
                }

                this._updateQueryParam(table);
            },

            updateTable(table: Table) {
                const event = this.getValue();

                if (event) {
                    if (table) {
                        if (event.first !== undefined && event.first !== null) {
                            // Mark that we're restoring state to prevent _updateQueryParam from removing the first param
                            this._restoringFirst = event.first;
                            // Set immediately
                            table.first = event.first;
                            // Also set it again after a delay to ensure it persists if PrimeNG resets it
                            // This handles the case where PrimeNG resets table.first during change detection
                            setTimeout(() => {
                                if (table) {
                                    if (table.first !== event.first) {
                                        table.first = event.first;
                                    }
                                    // If table.first now matches, trigger _updateQueryParam to clear the restoration flag
                                    if (table.first === event.first) {
                                        this._updateQueryParam(table);
                                    }
                                }
                            }, 200);
                        }

                        if (event.rows) {
                            table.rows = event.rows;
                        }

                        if (event.sortField) {
                            table.sortField = event.sortField;
                            table.sortOrder = event.sortOrder;
                        }

                        if (event.multiSortMeta) {
                            table.multiSortMeta = event.multiSortMeta;
                        }

                        if (event.globalFilter) {
                            table.filterGlobal(event.globalFilter, 'contains');
                        }

                        if (event.filters) {
                            Object.keys(event.filters).forEach(key => {
                                let filterMeta = event.filters[key];
                                if (!Array.isArray(filterMeta)) {
                                    filterMeta = [filterMeta];
                                }

                                // Handle multiple filters for the same column
                                if (filterMeta !== null && filterMeta.length > 0) {
                                    // Check if any filter has a valid value
                                    const hasValidFilters = filterMeta.some(filter =>
                                        filter.value !== null && filter.value !== undefined && filter.value !== ''
                                    );

                                    if (hasValidFilters) {
                                        filterMeta.forEach(filter => {
                                            (table as any).filter(filter.value, key, filter.matchMode, filter.operator);
                                        });
                                    }
                                }
                            });
                        }
                    }
                }
            },

            _initScrollWatcher() {
                // // Debounce scroll updates to avoid excessive URL changes
                // let scrollTimeout: any = null;

                // this._scrollHandler = () => {
                //     if (scrollTimeout) {
                //         clearTimeout(scrollTimeout);
                //     }

                //     scrollTimeout = setTimeout(() => {
                //         this._updateScrollPosition();
                //     }, 300); // 300ms debounce
                // };

                // window.addEventListener('scroll', this._scrollHandler);
            },

            _updateScrollPosition() {
                // const scrollY = window.scrollY || window.pageYOffset;

                // // Only update if scroll position is significant
                // if (scrollY > 0) {
                //     const currentParams = this._component.route.snapshot.queryParams;
                //     const paramsObject = { ...currentParams };
                //     paramsObject['scrollY'] = Math.round(scrollY).toString();

                //     this._component.routerService.navigate([], {
                //         queryParams: paramsObject,
                //         replaceUrl: true
                //     });
                // } else {
                //     // Remove scroll parameter if at top
                //     const currentParams = this._component.route.snapshot.queryParams;
                //     if (currentParams['scrollY']) {
                //         const paramsObject = { ...currentParams };
                //         delete paramsObject['scrollY'];

                //         this._component.routerService.navigate([], {
                //             queryParams: paramsObject,
                //             replaceUrl: true
                //         });
                //     }
                // }
            },

            _restoreScrollPosition() {
                // const queryParams = this._component.route.snapshot.queryParams;
                // if (queryParams['scrollY']) {
                //     const scrollY = parseInt(queryParams['scrollY']);
                //     if (!isNaN(scrollY)) {
                //         // Use setTimeout to ensure DOM is ready
                //         setTimeout(() => {
                //             window.scrollTo({
                //                 top: scrollY,
                //                 behavior: 'smooth'
                //             });
                //         }, 100);
                //     }
                // }
            },

            cleanup() {
                if (this._scrollHandler) {
                    window.removeEventListener('scroll', this._scrollHandler);
                    this._scrollHandler = null;
                }
            },

            getValue(): LazyLoadEvent {
                const queryParams = this._component.route.snapshot.queryParams;
                const lazyLoadEvent: LazyLoadEvent = {};

                if (queryParams['first']) lazyLoadEvent.first = parseInt(queryParams['first']);
                if (queryParams['rows']) lazyLoadEvent.rows = parseInt(queryParams['rows']);
                if (queryParams['sortField']) lazyLoadEvent.sortField = queryParams['sortField'];
                if (queryParams['sortOrder']) lazyLoadEvent.sortOrder = parseInt(queryParams['sortOrder']);
                if (queryParams['globalFilter']) lazyLoadEvent.globalFilter = queryParams['globalFilter'];

                if (queryParams['multiSortMeta']) {
                    try {
                        lazyLoadEvent.multiSortMeta = JSON.parse(queryParams['multiSortMeta']);
                    } catch (e) {
                        console.error('Error parsing multiSortMeta', e);
                    }
                }

                if (queryParams['filters']) {
                    try {
                        lazyLoadEvent.filters = JSON.parse(queryParams['filters']);
                    } catch (e) {
                        console.error('Error parsing filters', e);
                    }
                }

                return lazyLoadEvent;
            },

            _updateQueryParam(table: Table) {
                // Get current query params to preserve non-table parameters
                const currentParams = this._component.route.snapshot.queryParams;
                const paramsObject = { ...currentParams };

                // Handle pagination parameters
                // If we're restoring state and table.first is temporarily 0, preserve the URL param
                if (this._restoringFirst !== null && this._restoringFirst !== undefined) {
                    // If table.first now matches the desired value, we can clear the restoration flag
                    if (table?.first === this._restoringFirst) {
                        paramsObject['first'] = table.first.toString();
                        this._restoringFirst = null;
                    } else {
                        // Still restoring - preserve the URL param
                        paramsObject['first'] = this._restoringFirst.toString();
                    }
                } else if (table?.first !== undefined && table.first !== null && table.first !== 0) {
                    paramsObject['first'] = table.first.toString();
                } else {
                    delete paramsObject['first'];
                }

                if (table?.rows !== undefined && table.rows !== null && table.rows !== 0) {
                    paramsObject['rows'] = table.rows.toString();
                } else {
                    delete paramsObject['rows'];
                }

                // Handle sorting parameters
                if (table?.sortField && table?.sortOrder !== undefined && table?.sortOrder !== null && table.sortOrder !== 0) {
                    paramsObject['sortField'] = table.sortField;
                    paramsObject['sortOrder'] = table.sortOrder.toString();
                } else {
                    delete paramsObject['sortField'];
                    delete paramsObject['sortOrder'];
                }

                // Handle global filter
                if (table?.filters?.global && (table.filters.global as FilterMetadata).value && (table.filters.global as FilterMetadata).value !== '') {
                    paramsObject['globalFilter'] = (table.filters.global as FilterMetadata).value;
                } else {
                    delete paramsObject['globalFilter'];
                }

                // Handle multi-sort metadata
                if (table?.multiSortMeta && Array.isArray(table.multiSortMeta) && table.multiSortMeta.length > 0) {
                    paramsObject['multiSortMeta'] = JSON.stringify(table.multiSortMeta);
                } else {
                    delete paramsObject['multiSortMeta'];
                }

                // Handle column filters
                if (table?.filters) {
                    var filtres = JSON.parse(JSON.stringify(table.filters));
                    delete filtres.global;

                    Object.keys(filtres).forEach(key => {
                        if (!Array.isArray(filtres[key])) {
                            filtres[key] = [filtres[key]];
                        }

                        // Remove filters with null/undefined/empty values
                        if (Array.isArray(filtres[key])) {
                            filtres[key] = filtres[key].filter(filter =>
                                filter.value !== null && filter.value !== undefined && filter.value !== ''
                            );

                            // If no valid filters remain for this column, remove the entire column
                            if (filtres[key].length === 0) {
                                delete filtres[key];
                            }
                        } else if (filtres[key].value == null || filtres[key].value == undefined || filtres[key].value == '') {
                            delete filtres[key];
                        }
                    });

                    if (Object.keys(filtres).length > 0) {
                        paramsObject['filters'] = JSON.stringify(filtres);
                    } else {
                        delete paramsObject['filters'];
                    }
                } else {
                    delete paramsObject['filters'];
                }

                this._component.routerService.navigate([], {
                    queryParams: paramsObject,
                    replaceUrl: true
                });
            },

            _firstLoad: true,
            _component: this,
            _scrollHandler: null as any,
            _restoringFirst: null as number
        };

        wrapper._restoreScrollPosition();

        // Track the filter for cleanup on navigation
        this.tableFilters.push(wrapper);

        return wrapper;
    }

    generateSolidColorImage(width, height, color) {
        if (this.colorImageCache.has(color)) {
            return this.colorImageCache.get(color);
        }
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = color;
        ctx.fillRect(0, 0, width, height);
        const dataUrl = canvas.toDataURL();
        this.colorImageCache.set(color, dataUrl);
        return dataUrl;
    }

    get HttpEventType() {
        return HttpEventType;
    }

    /**
     * Cleanup method to be called in the ngOnDestroy of components that extend BaseComponent
     */
    protected cleanup(): void {
        if (this.subscriptions) {
            this.subscriptions.forEach(sub => sub.unsubscribe());
            this.subscriptions = [];
        }

        // Cleanup table filters (remove scroll event listeners)
        if (this.tableFilters) {
            this.tableFilters.forEach(filter => {
                if (filter.cleanup) {
                    filter.cleanup();
                }
            });
            this.tableFilters = [];
        }
    }

    fromString<T>(value: any): T {
        // If value is not a string, just return it
        if (typeof value !== 'string') return value as T;

        // Null/undefined
        if (value == null) return null as any;

        // Try to detect booleans
        if (value === 'true') return true as any as T;
        if (value === 'false') return false as any as T;

        // Try to detect numbers
        if (!isNaN(Number(value)) && value.trim() !== '') return Number(value) as any as T;

        // Try to detect arrays (simple CSV style)
        if (value.startsWith('[') && value.endsWith(']')) {
            try {
                // Remove brackets and split, trim spaces
                const arr = value.slice(1, -1).split(',').map(v => this.fromString(v.trim()));
                return arr as any as T;
            } catch {
                return [] as any as T;
            }
        }

        // Try to detect objects (very limited: {key:value,...})
        if (value.startsWith('{') && value.endsWith('}')) {
            try {
                // Extremely simplified object decoder
                const objString = value.slice(1, -1);
                const obj: any = {};
                const pairs = objString.split(',').map(s => s.trim());
                for (const pair of pairs) {
                    if (!pair) continue;
                    const [k, v] = pair.split(':').map(str => str.trim());
                    // Remove possible quotes around keys/values
                    const key = k.replace(/^"(.+)"$/, '$1').replace(/^'(.+)'$/, '$1');
                    obj[key] = this.fromString(v);
                }
                return obj as T;
            } catch {
                return {} as any as T;
            }
        }

        // Default: string, remove quotes if present
        if (
            (value.startsWith('"') && value.endsWith('"'))
            || (value.startsWith("'") && value.endsWith("'"))
        ) {
            return value.substring(1, value.length - 1) as any as T;
        }
        return value as any as T;
    }
}